import Image from "./../image";

export default function HomeBeetleLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-screen flex justify-center bg-white">
      <div
        className="w-full max-w-[480px] min-h-screen flex flex-col bg-white"
        style={{ fontFamily: "Poppins, sans-serif" }}
      >
        <header className="flex justify-center w-full px-4 pt-14 pb-6">
          <Image
            src="/assets/beetle_logo.png"
            alt="beetle-logo"
            width={238}
            height={72}
          />
        </header>
        {children}
        <Image
          src="/assets/beetle_bg.png"
          alt=""
          className="w-full h-auto mt-auto block"
        />
      </div>
    </div>
  );
}
